import { render } from "./AppLoader.vue?vue&type=template&id=ce53a27c&scoped=true"
import script from "./AppLoader.vue?vue&type=script&lang=js"
export * from "./AppLoader.vue?vue&type=script&lang=js"

import "./AppLoader.vue?vue&type=style&index=0&id=ce53a27c&lang=scss&scoped=true"

import exportComponent from "/home/runner/work/GB-Frontend/GB-Frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ce53a27c"]])

export default __exports__